import React from "react"
import PropTypes from "prop-types"
import { CmsImage } from "@bw/bits"
import { Link } from "gatsby"
import * as css from "./Highlights.module.css"

const Highlights = ({ points }) => {
  if (!points) {
    return null
  }

  let gridclass = css.grid
  if (points.length > 2) {
    gridclass += ` ${css.grid_3_columns}`
  }

  return (
    <div className={`${gridclass} highlights`}>
      {points.map(
        (
          {
            title,
            description,
            image,
            url,
            entry,
            isExternal,
            openInModal,
            linkText,
          },
          i
        ) => {
          return (
            <Anchor
              key={i}
              to={entry?.url}
              href={url}
              isExternal={isExternal}
              modal={openInModal}
              className={`${css.wrapper} highlight`}
            >
              {image && (
                <CmsImage
                  src={image}
                  alt={image?.alt}
                  className={`${css.image} highlight__image`}
                />
              )}
              <div className={`${css.body} highlight__body`}>
                {title && (
                  <h3 className={`${css.title} highlight__title`}>{title}</h3>
                )}
                {description && (
                  <div className={`${css.description} highlight__description`}>
                    {description}
                  </div>
                )}
                {linkText && (
                  <div className={`${css.button} highlight__button`}>
                    {linkText}
                  </div>
                )}
              </div>
            </Anchor>
          )
        }
      )}
    </div>
  )
}

const Anchor = ({ children, to, href, isExternal, modal, className }) => {
  if (to && !isExternal) {
    return (
      <Link to={to} className={className}>
        {children}
      </Link>
    )
  }

  if (href || (to && isExternal)) {
    return (
      <a
        href={href ?? to}
        rel={isExternal ? "noopener noreferrer" : null}
        target={isExternal ? "_blank" : null}
        className={className}
      >
        {children}
      </a>
    )
  }

  return <div className={className}>{children}</div>
}

Highlights.propTypes = {
  points: PropTypes.array,
}

export { Highlights }
